module.exports = __webpack_public_path__ + "static/media/picture9.1ed68da0.jpg";